import { Spinner } from '@/components/ui/spinner.tsx';

export const PageLoader = () => {
  return (
    <div className="flex items-center justify-center h-full">
      <Spinner size="large" />
    </div>
  );
};
